export enum ProfileSourceType {
    personal = 'personal',
    franchiser = 'provider',
}
